export interface AppNotificationPreferences {
  profileId: string;
  globalEnabled: boolean;
  activityProfileViews: boolean;
  activityFollowers: boolean;
  activityMessages: boolean;
  activityRatings: boolean;
  activityFrequency?: string;
  summaryDaily: boolean;
  summaryWeekly: boolean;
  marketingPromotions: boolean;
  pushEnabled: boolean;
  emailEnabled: boolean;
}

export const DEFAULT_NOTIFICATION_PREFERENCES: Omit<AppNotificationPreferences, 'profileId'> = {
  globalEnabled: true,
  activityProfileViews: true,
  activityFollowers: true,
  activityMessages: true,
  activityRatings: true,
  summaryDaily: false,
  summaryWeekly: true,
  marketingPromotions: false,
  pushEnabled: true,
  emailEnabled: true,
};
